import axios from 'axios';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

export const PAGINATION_PARAMS = {
    name: '',
    pageNumber: 0,
    resultPerPage: 1000,
};

export const fetchFaculties = () => axios.get('/graduation-documents/faculties');
export const fetchPositions = () => axios.get('/positions');
export const fetchAcademicYears = () => axios.get('/academic-years/current-and-previous/', { params: PAGINATION_PARAMS });
export const fetchAllAcademicYears = () => axios.get('/academic-years', { params: PAGINATION_PARAMS });
export const fetchStudyCycle = () => axios.get('/study-cycles', { params: PAGINATION_PARAMS });
export const fetchStudyType = () => axios.get('/study-types');
export const fetchStudentStatuses = () => axios.get('/student-statuses');
export const fetchGenderName = () => axios.get('/genders');
export const fetchLanguages = () => axios.get('/languages');
export const fetchDocumentTypes = () => axios.get('/document-types');
export const fetchDocumentStatuses = () => axios.get('/document-statuses');
export const fetchCountries = () => axios.get('/countries');
export const fetchCantonss = () => axios.get('/cantons');
export const fetchMunicipality = () => axios.get('/municipalities');
export const fetchCertificateReasons = () => axios.get('/certificate-reasons');
export const fetchDocumentTemplates = () => axios.get('/document-templates');
export const fetchMarks = () => axios.get('/marks');
export const fetchCurrentAcademicYear = () => axios.get('/academic-years/current');
export const fetchPreviousAcademicYear = () => axios.get('/academic-years/previous');
export const fetchTitles = () => axios.get('/titles');
export const fetchGroupTypes = () => axios.get('/group-types');
export const fetchEmployeeTypes = () => axios.get('/employee-types');
export const fetchSPSemesters = () => axios.get('/study-program-semesters');
export const fetchSPStatuses = () => axios.get('/study-program-statuses');
export const fetchStudyYears = () => axios.get('/semester/study-years/');
export const fetchSPBAndDepartments = (courseImplementationId) => axios.get(`professor/study-program-basics-and-departments-by-course/${courseImplementationId}`);

export default { PAGINATION_PARAMS };



// WEBPACK FOOTER //
// ./src/views/Lookups/util.js